import { createTheme, type MantineTheme, NumberInput } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

import { inputStyles, themedMantineInput } from './Input';

export const ThemedMantineNumberInput: PartialDeep<MantineTheme> = createTheme({
  components: {
    NumberInput: NumberInput.extend({
      styles: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return themedMantineInput(theme);
      },
      classNames: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return { input: inputStyles.input(theme) };
      },
    }),
  },
});
